// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c37e4fb5","453":"5431b0dd","667":"f2eceacc","977":"ccc457de"}[chunkId] + ".chunk.js";
};